
(function(){
    angular.module('tmx-app').factory('OtpService', ['tmxResource',
        function(tmxResource){

            var masterdata= tmxResource("Otp");

            masterdata.VerifyOTPByUserId=VerifyOTPByUserId;
            masterdata.GenerateOTPByUserId = GenerateOTPByUserId;


            function VerifyOTPByUserId(userId, otp){
                return  masterdata.getByAction("VerifyOTPByUserId/"+userId+"/"+otp,false);
            }

            function GenerateOTPByUserId(userId){
                return  masterdata.getByAction("GenerateOTPByUserId/"+userId,false);
            }

            return masterdata;

        }]);
})();
